var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu md:hidden",class:[_vm.syncedShowModal ? 'modal-show' : 'modal-hidden']},[_c('div',{staticClass:"nav-container",on:{"click":_vm.closeModal}},[_c('tOptions')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }